let callNameMap = {
  0: {
    name: 'CONST_EU_CALL_AcceptCall_0'
  },
  1: {
    name: 'CONST_EU_CALL_AcceptCallAck_1'
  },
  2: {
    name: 'CONST_EU_CALL_AnswerCall_2'
  },
  3: {
    name: 'CONST_EU_CALL_AnswerCallAck_3'
  },
  4: {
    name: 'CONST_EU_CALL_ConnectCall_4'
  },
  5: {
    name: 'CONST_EU_CALL_ConnectCallAck_5'
  },
  6: {
    name: 'CONST_EU_CALL_ClearCall_6'
  },
  7: {
    name: 'CONST_EU_CALL_ClearCallAck_7'
  },
  8: {
    name: 'CONST_EU_CALL_ClearConnection_8'
  },
  9: {
    name: 'CONST_EU_CALL_ClearConnectionAck_9'
  },
  10: {
    name: 'CONST_EU_CALL_HeldCall_10'
  },
  11: {
    name: 'CONST_EU_CALL_HeldCallAck_11'
  },
  12: {
    name: 'CONST_EU_CALL_MakeCall_12'
  },
  13: {
    name: 'CONST_EU_CALL_MakeCallAck_13'
  },
  14: {
    name: 'CONST_EU_CALL_MakeOnePartCall_14'
  },
  15: {
    name: 'CONST_EU_CALL_MakeOnePartCallAck_15'
  },
  16: {
    name: 'CONST_EU_CALL_CreateConferenceCall_16'
  },
  17: {
    name: 'CONST_EU_CALL_CreateConferenceCallAck_17'
  },
  18: {
    name: 'CONST_EU_CALL_JoinConferenceCall_18'
  },
  19: {
    name: 'CONST_EU_CALL_JoinConferenceCallAck_19'
  },
  20: {
    name: 'CONST_EU_CALL_ChangeConferenceMode_20'
  },
  21: {
    name: 'CONST_EU_CALL_ChangeConferenceModeAck_21'
  },
  22: {
    name: 'CONST_EU_CALL_ConferenceCall_22'
  },
  23: {
    name: 'CONST_EU_CALL_ConferenceCallAck_23'
  },
  24: {
    name: 'CONST_EU_CALL_ConsultationCall_24'
  },
  25: {
    name: 'CONST_EU_CALL_ConsultationCallAck_25'
  },
  26: {
    name: 'CONST_EU_CALL_DeflectCall_26'
  },
  27: {
    name: 'CONST_EU_CALL_DeflectCallAck_27'
  },
  28: {
    name: 'CONST_EU_CALL_CallOfferEvent_28'
  },
  29: {
    name: 'CONST_EU_CALL_ConnectionClearedEvent_29'
  },
  30: {
    name: 'CONST_EU_CALL_HeldEvent_30'
  },
  31: {
    name: 'CONST_EU_CALL_AnswerCallEvent_31'
  },
  32: {
    name: 'CONST_EU_CALL_BeginReceiveDTMF_32'
  },
  33: {
    name: 'CONST_EU_CALL_BeginReceiveDTMFAck_33'
  },
  34: {
    name: 'CONST_EU_CALL_EndReceiveDTMF_34'
  },
  35: {
    name: 'CONST_EU_CALL_EndReceiveDTMFAck_35'
  },
  36: {
    name: 'CONST_EU_CALL_PlayFile_36'
  },
  37: {
    name: 'CONST_EU_CALL_PlayFileAck_37'
  },
  38: {
    name: 'CONST_EU_CALL_PlayFileList_38'
  },
  39: {
    name: 'CONST_EU_CALL_PlayFileListAck_39'
  },
  40: {
    name: 'CONST_EU_CALL_StopPlayFile_40'
  },
  41: {
    name: 'CONST_EU_CALL_StopPlayFileAck_41'
  },
  42: {
    name: 'CONST_EU_CALL_SetPlayFileVolume_42'
  },
  43: {
    name: 'CONST_EU_CALL_SetPlayFileVolumeAck_43'
  },
  44: {
    name: 'CONST_EU_CALL_StartRecordFile_44'
  },
  45: {
    name: 'CONST_EU_CALL_StartRecordFileAck_45'
  },
  46: {
    name: 'CONST_EU_CALL_StopRecordFile_46'
  },
  47: {
    name: 'CONST_EU_CALL_StopRecordFileAck_47'
  },
  48: {
    name: 'CONST_EU_CALL_StartSendFax_48'
  },
  49: {
    name: 'CONST_EU_CALL_StartSendFaxAck_49'
  },
  50: {
    name: 'CONST_EU_CALL_StopSendFax_50'
  },
  51: {
    name: 'CONST_EU_CALL_StopSendFaxAck_51'
  },
  52: {
    name: 'CONST_EU_CALL_StartReceiveFax_52'
  },
  53: {
    name: 'CONST_EU_CALL_StartReceiveFaxAck_53'
  },
  54: {
    name: 'CONST_EU_CALL_StopReceiveFax_54'
  },
  55: {
    name: 'CONST_EU_CALL_StopReceiveFaxAck_55'
  },
  56: {
    name: 'CONST_EU_CALL_OnReceiveDTMFCompleted_56'
  },
  57: {
    name: 'CONST_EU_CALL_OnPlayFileCompleted_57'
  },
  58: {
    name: 'CONST_EU_CALL_OnRecordFileCompleted_58'
  },
  59: {
    name: 'CONST_EU_CALL_OnSendFaxCompleted_59'
  },
  60: {
    name: 'CONST_EU_CALL_OnReceiveFaxCompleted_60'
  },
  61: {
    name: 'CONST_EU_CALL_TransCallToAnotherAppWithData_61'
  },
  62: {
    name: 'CONST_EU_CALL_TransCallToAnotherAppWithDataAck_62'
  },
  63: {
    name: 'CONST_EU_CALL_CallOfferEventFromAnotherApp_63'
  },
  64: {
    name: 'CONST_EU_CALL_TTSPlay_64'
  },
  65: {
    name: 'CONST_EU_CALL_TTSPlayAck_65'
  },
  66: {
    name: 'CONST_EU_CALL_CallBindAgent_66'
  },
  67: {
    name: 'CONST_EU_CALL_CallBindAgentAck_67'
  },
  68: {
    name: 'CONST_EU_CALL_NotifyAgentEvt_68'
  },
  69: {
    name: 'CONST_EU_CALL_VDNStatEvt_69'
  },
  70: {
    name: 'CONST_EU_CALL_LineStatusEvt_70'
  },
  71: {
    name: 'CONST_EU_CALL_AutoDial_71'
  },
  72: {
    name: 'CONST_EU_CALL_SetAgentStatus4ExitConf_72'
  },
  73: {
    name: 'CONST_EU_CALL_ExitConference_73'
  },
  74: {
    name: 'CONST_EU_CALL_ExitConferenceAck_74'
  },
  75: {
    name: 'CONST_EU_CALL_LastFunction_75'
  },
  103: {
    name: 'CONST_EU_CALL_OnReceiveDTMFCompleted_103'
  }
}

export default {

  showCallMessageName: function (msgfunc) {
    let call = callNameMap[msgfunc]
    if (call)
      return call.name
    else
      return msgfunc.toString()
  }
}